import { ChevronRightRounded } from '@material-ui/icons'
import Link from 'components/link'
import css from './AddItemsLinks.styles.scss'

export interface AddItemsLink {
  iconUrl: string
  label: string
  description: string
  href?: string
  onClick?: () => void
}
interface AddItemsLinkProps {
  link: AddItemsLink
}
const AddItemsLink = ({
  link: { iconUrl, label, description, href, onClick },
}: AddItemsLinkProps) => (
  <Link className={css.root} url={href} onClick={onClick}>
    <div className={css.iconContainer}>
      <img alt="icon" role="presentation" src={iconUrl} />
    </div>
    <div>
      <p className={css.label}>{label}</p>
      <p className={css.description}>{description}</p>
    </div>
    <ChevronRightRounded className={css.chevron} />
  </Link>
)

export default AddItemsLink
